import styles from "./MyAccount.module.scss"; // SCSS stilini əlavə edirik
import InputComponent from "../../../components/shared/input/InputComponent";
import SelectComponent from "../../../components/shared/select/SelectComponent";
import MainButton from "../../../components/shared/button/MainButton";
import PhoneInputComponent from "../../../components/shared/input-phone-component/PhoneInputComponent";
import CheckBoxSelected from "../../../components/shared/checkBoxSelected/CheckBoxSelected";
import { useEffect, useRef, useState } from "react";
import { AccountUserService } from "../../../services/myAccount.service";
import TitleUpdater from "../../../components/shared/title/TitleUpdater";
import { toast } from "react-toastify";
import { useSite } from "../../../context/TranslationContext";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchTranslation } from "../../../redux/Slices/translationDataSlice";

const MyAccount: React.FC = () => {
  const [isShowPassword, setIsShowPassword] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const language = useSelector((state: RootState) => state.language.language);

  const [isShowConfrimPassword, setIsShowConfrimPassword] = useState(false);
  const [isShowNewPassword, setIsShowNewPassword] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const { data } = useSelector((state: RootState) => state.translationData);
  const [initialFormValues, setInitialFormValues] = useState<{
    [key: string]: string;
  } | null>(null);
  const [userData, setUserData] = useState<any>(null);

  const [formValues, setFormValues] = useState({
    name: "",
    surname: "",
    citizenship: "",
    voen: "",
    company: "",
    email: "",
    passport_series: "",
    passport_number: "",
    birthday: "",
    passport_fin: "",
    phone1: "",
    gender: "",
    language: "",
    address: "",
    password_new: "",
    password_confirm: "",
    passport_prefix: "",
    password_old: "",
    phone2_prefix: "",
    phone2: "",
    phone1_prefix: "",
    phone1_number: "",
    phone2_number: "",
  });

  useEffect(() => {
    AccountUserService.GetUsers().then((res) => {
      const user = res.data.original;
      setUserData(user);
      const citizenship = user.citizenship?.toString() || "";

      if (citizenship === "1") {
        setPassportSeriesOptions([
          { value: "AA", label: "AA" },
          { value: "AZE", label: "AZE" },
          { value: "AB", label: "AB" },
        ]);
      } else if (citizenship === "2") {
        setPassportSeriesOptions([
          { value: "MYI", label: "MYI" },
          { value: "DYI", label: "DYI" },
        ]);
      }
      const initialValues = {
        name: user.name || "",
        surname: user.surname || "",
        citizenship: user.citizenship || "",
        voen: user.voen || "",
        company: user.firm || user.company || "",
        email: user.email || "",
        passport_series: user.passport_series || "",
        passport_prefix: user.passport_series || "",
        passport_number: user.passport_number || "",
        birthday: user.birthday || "",
        passport_fin: user.passport_fin || "",
        phone1: (user.phone1_prefix || "") + (user.phone1_number || ""),
        gender: user.gender?.toString() || "",
        language: user.language || "",
        address: user.address1 || "",
        password_new: "",
        password_confirm: "",
        password_old: "",
        phone2_prefix: user.phone2_prefix || "50",
        phone2: user.phone2_number || "",
        phone1_prefix: user.phone1_prefix || "",
        phone1_number: user.phone1_number || "",
        phone2_number: user.phone2_number || "",
      };

      setFormValues(initialValues);
      setInitialFormValues(initialValues);
    });
  }, []);

  useEffect(() => {
    if (formValues.citizenship === "1") {
      setPassportSeriesOptions([
        { value: "AA", label: "AA" },
        { value: "AZE", label: "AZE" },
      ]);
    } else if (formValues.citizenship === "2") {
      setPassportSeriesOptions([
        { value: "MYI", label: "MYI" },
        { value: "DYI", label: "DYI" },
      ]);
    }
  }, [formValues.citizenship]);

  const handleInputChange = (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
      | { target: { name: string; value: string | number } },
  ) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: String(value),
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const payload: any = {
      ...formValues,
      full_passport_number: `${formValues.passport_series}${formValues.passport_number}`,
      password_new: formValues.password_new,
      phone2_prefix: formValues.phone2_prefix,
      phone2_number: formValues.phone2,
    };

    if (userData?.is_legality === 1) {
      delete payload.passport_fin;
      delete payload.passport_number;
      delete payload.passport_prefix;
      delete payload.passport_series;
    }

    try {
      const response = await AccountUserService.PostUserInfo(payload);
      if (response.status === 200) {
        toast.success(data?.data_updated);
        setInitialFormValues(formValues);
      }
    } catch (error: any) {
      if (error.response?.data?.errors) {
        const backendErrors = error.response.data.errors;
        setErrors(backendErrors);
      }
    }
  };
  const [passportSeriesOptions, setPassportSeriesOptions] = useState([
    { value: "AA", label: "AA" },
    { value: "AZE", label: "AZE" },
    { value: "MYI", label: "MYI" },
    { value: "DYI", label: "DYI" },
  ]);

  const isFormChanged = (): boolean => {
    if (!initialFormValues) return false;

    for (const key in formValues) {
      const typedKey = key as keyof typeof formValues;
      if (formValues[typedKey] !== initialFormValues[typedKey]) {
        return true;
      }
    }
    return false;
  };

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      if (!data) {
        dispatch(fetchTranslation());
      }
    } else {
      dispatch(fetchTranslation());
    }
  }, [dispatch, language]);

  return (
    <>
      <form
        id={styles.account_purchase}
        onSubmit={handleSubmit}
        autoComplete="off"
      >
        <TitleUpdater
          title={
            data?.colibri && data?.auth_common_my_account
              ? `${data?.colibri} | ${data?.auth_common_my_account}`
              : "Colibri"
          }
        />
        <div className={styles.account_row}>
          <InputComponent
            label={data?.auth_referal_first_name}
            type="text"
            name="name"
            placeholder={data?.auth_referal_first_name}
            value={formValues.name}
            onChange={handleInputChange}
            readOnly={true}
            disabled
          />

          <InputComponent
            label={data?.auth_referal_last_name}
            type="text"
            name="surname"
            placeholder={data?.auth_referal_last_name}
            value={formValues.surname}
            onChange={handleInputChange}
            readOnly={true}
            disabled
          />
          <SelectComponent
            label={data?.auth_common_citizenship}
            name="citizenship"
            options={[
              { value: "1", label: `${data?.azerbaijani}` },
              { value: "2", label: `${data?.foreign_citizen}` },
            ]}
            selectedValue={String(formValues.citizenship)}
            onChange={(value) => {
              setFormValues({ ...formValues, citizenship: value.toString() });
            }}
          />

          {userData?.is_legality === 1 && (
            <>
              <InputComponent
                label={data?.auth_common_voen}
                type="text"
                name="voen"
                placeholder={data?.auth_common_voen}
                value={formValues.voen}
                onChange={handleInputChange}
              />

              <InputComponent
                label={data?.auth_common_company}
                type="text"
                name="company"
                placeholder={data?.auth_common_company}
                value={formValues.company}
                onChange={handleInputChange}
              />
            </>
          )}

          <InputComponent
            label={data?.auth_referal_email}
            type="email"
            name="email"
            placeholder={data?.auth_referal_email}
            value={formValues.email}
            onChange={handleInputChange}
            error={errors?.email?.[0]}
          />
          {userData?.is_legality === 0 && (
            <>
              <div className={styles.accountrow_resies}>
                <div className={styles.nameSelect}>
                  <SelectComponent
                    label={data?.auth_referal_passport_series}
                    name="passport_series"
                    options={passportSeriesOptions}
                    value={formValues.passport_series}
                    onChange={(value) =>
                      handleInputChange({
                        target: { name: "passport_series", value },
                      })
                    }
                    className={styles.passportSeries}
                    placeholder={data?.auth_attorney_select}
                    selectedValue={formValues?.passport_series}
                    error={errors?.passport_series}
                    disabled={!formValues.citizenship}
                  />
                </div>

                <InputComponent
                  label={data?.auth_attorney_series_number}
                  type="number"
                  name="passport_number"
                  placeholder={data?.auth_attorney_series_number}
                  value={formValues.passport_number}
                  onChange={handleInputChange}
                  className={styles.pasport}
                  error={errors?.passport_number?.[0]}
                />
              </div>

              <InputComponent
                label={data?.auth_referal_passport_fin}
                type="text"
                name="fin"
                placeholder={data?.auth_referal_passport_fin}
                value={formValues.passport_fin}
                onChange={handleInputChange}
                readOnly={true}
                disabled
              />
            </>
          )}

          <div
            className={styles.dateinputWrapper}
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <div
              className={styles.dateinputWrapper}
              style={{ width: "100%", marginTop: "5px" }}
            >
              {data?.auth_referal_birth_date}
              <div className={styles.dateInputWrapper}>
                <InputComponent
                  // label="Doğum Tarixi"
                  type="date"
                  name="birthday"
                  placeholder="__/__/____"
                  value={formValues.birthday}
                  onChange={handleInputChange}
                />
              </div>
              <p className={styles.errorMsg}> {errors.birthday}</p>
            </div>
          </div>

          {/* <InputComponent
            label="Doğum Tarixi"
            type="text"
            name="birthday"
            placeholder="__/__/____"
            value={formValues.birthday}
            onChange={handleInputChange}
          /> */}

          <PhoneInputComponent
            label={data?.auth_referal_phone_number}
            id="phone1"
            name="phone1"
            placeholder={data?.auth_referal_phone_number || ""}
            value={formValues.phone1_number}
            onChange={handleInputChange}
            selectedCode={formValues.phone1_prefix}
            onCodeChange={() => {}}
            error={""}
            readOnly={true}
            disabled
          />

          <PhoneInputComponent
            label={data?.auth_common_additional_phone}
            id="phone2"
            name="phone2"
            placeholder="0000000"
            value={formValues.phone2_number}
            selectedCode={formValues.phone2_prefix}
            onChange={(e) => {
              setFormValues((prev) => ({ ...prev, phone2: e.target.value }));
            }}
            onCodeChange={(code) => {
              setFormValues((prev) => ({ ...prev, phone2_prefix: code }));
            }}
            error={errors?.phone2?.[0]}
          />
          <InputComponent
            label={data?.auth_referal_address}
            type="text"
            name="address"
            placeholder={data?.auth_referal_address}
            value={formValues.address}
            onChange={handleInputChange}
          />
          <CheckBoxSelected
            value={formValues.gender}
            onChange={(value) => {
              setFormValues({ ...formValues, gender: value.toString() });
            }}
            error={""}
            disabled
          />

          <SelectComponent
            label={data?.auth_referal_language_select}
            name="language"
            options={[
              { value: "AZ", label: "AZ" },
              { value: "EN", label: "EN" },
              { value: "RU", label: "RU" },
            ]}
            selectedValue={formValues.language}
            onChange={(value) =>
              handleInputChange({ target: { name: "language", value } })
            }
            placeholder={data?.auth_attorney_select}
          />

          <InputComponent
            label={data?.auth_common_current_password}
            type="password"
            name="password_old"
            placeholder={data?.auth_common_current_password}
            isPassword={true}
            isShowPassword={isShowPassword}
            toggleShowPassword={() => setIsShowPassword(!isShowPassword)}
            value={formValues.password_old}
            onChange={handleInputChange}
            error={errors?.password_old?.[0]}
            autoComplete
          />
          <InputComponent
            label={data?.auth_common_new_password}
            type="password"
            name="password_new"
            placeholder={data?.auth_common_new_password}
            value={formValues.password_new}
            onChange={handleInputChange}
            isPassword={true}
            isShowPassword={isShowNewPassword}
            toggleShowPassword={() => setIsShowNewPassword(!isShowNewPassword)}
            error={errors?.password_new?.[0]}
            autoComplete
          />
          <InputComponent
            label={data?.auth_common_repeat_password}
            type="password"
            name="password_confirm"
            placeholder={data?.auth_common_repeat_password}
            value={formValues.password_confirm}
            onChange={handleInputChange}
            isPassword={true}
            isShowPassword={isShowConfrimPassword}
            toggleShowPassword={() =>
              setIsShowConfrimPassword(!isShowConfrimPassword)
            }
            error={errors?.password_confirm?.[0]}
            autoComplete
          />
        </div>
        <div className={styles.submit_btn}>
          <MainButton
            text={data?.auth_amazon_confirm}
            type="submit"
            disabled={!isFormChanged()}
          />
        </div>
      </form>
    </>
  );
};

export default MyAccount;
